import { faCircleMinus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isValid, parseISO } from "date-fns";
import { useTranslation } from "@onefront/react-sdk";
import {
  AdapterDateFns,
  DesktopDatePicker,
  LocalizationProvider,
} from "@vapor/react-x-date-pickers";
import { it } from "date-fns/locale";

const ClassificationDatePicker = ({
  width,
  label1,
  onChange,
  value,
  key,
  required,
}) => {
  const { t } = useTranslation("DOCS");

  const handleChange = (newDate) => {
    const formattedDate = newDate ? newDate : null;
    onChange({ target: { value: formattedDate } });
  };

  const parseDate = (dateString) => {
    if (!dateString) return null;
    const parsed = parseISO(dateString);
    return isValid(parsed) ? parsed : null;
  };

  return (
    <>
      <LocalizationProvider locale={it} dateAdapter={AdapterDateFns}>
        <div
          style={{
            width: "100%",
            display: "inline",
            marginRight: 10,
          }}
        >
          <DesktopDatePicker
            key={key}
            label={label1}
            value={parseDate(value)}
            onChange={handleChange}
            slotProps={{
              textField: {
                sx: {
                  width: "30%",
                  marginTop: 1.3,
                },
                helperText:
                  value === "" && required.required ? (
                    <div>
                      <FontAwesomeIcon icon={faCircleMinus} />{" "}
                      {t("classification.errorMessage")}
                    </div>
                  ) : (
                    " "
                  ),
              },
            }}
          />
        </div>
      </LocalizationProvider>
    </>
  );
};

export default ClassificationDatePicker;
